module.exports = __webpack_public_path__ + "img/Päuschen.882be94f.svg";